import type { AnalyticsEventLogger } from './types';

export class AnalyticsTracker {
  private eventLogger: AnalyticsEventLogger;

  constructor(eventLogger: AnalyticsEventLogger) {
    this.eventLogger = eventLogger;
  }

  trackFormLoad(form: any, vehicle: any, featureApp: any, promotion?: any): void {
    console.log('Analytics: Form Load triggered');
    this.eventLogger.logFormLoad(form, vehicle, featureApp, promotion);
  }

  trackFormSubmissionSuccess(form: any, vehicle: any, featureApp: any, promotion?: any): void {
    console.log('Analytics: Form Submission Success');
    this.eventLogger.logFormSubmissionSuccess(form, vehicle, featureApp, promotion);
  }

  trackFormSubmissionError(
    form: any,
    vehicle: any,
    featureApp: any,
    promotion: any,
    error: any,
  ): void {
    console.log('Analytics: Form Submission Error');
    this.eventLogger.logFormSubmissionError(form, vehicle, featureApp, promotion, error);
  }
}
